module.exports = __webpack_public_path__ + "media/customizations/roselyn/logo-0b11b5331a440d2ccfed5c6b644c30a5.png";